module.exports = __webpack_public_path__ + "img/04.029f2a04.png";